"use strict";
function isFunction(x) {
    return typeof x === 'function';
}
exports.isFunction = isFunction;
//# sourceMappingURL=isFunction.js.map


//////////////////
// WEBPACK FOOTER
// /app/SPA/~/rxjs/util/isFunction.js
// module id = ../../../../rxjs/util/isFunction.js
// module chunks = 4